
import './pl_landlord.css';
import StaffMockHost from './staff-mock-host.vue';
import DialogConfirm from '../owner/widgets/dialog-confirm.vue';
import VarList from '../owner/widgets/var-list.vue';
import FormulaEdit from './formula-edit.vue';
import FormulaTip, { closeAllFormulaTips } from './formula-tip.vue';
import DialogNotice from '../owner/widgets/dialog-notice.vue';
import ImportantNotice from '../owner/widgets/important-notice.vue';
import EXTRA_ITEM_CATALOG from './extra-item-catalog.js';

var FORMULA_KEYS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
var IJK_KEYS = ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
var SKIP_EXTRA = {
  A: 1, B: 1, C: 1, D: 1, E: 1, F: 1, G: 1, H: 1, owner_income: 1
};
var RESERVED_CODES = {
  A: 1, B: 1, C: 1, D: 1, E: 1, F: 1, G: 1, H: 1, I: 1, J: 1, K: 1,
  income: 1, stay_tax: 1, owner_income: 1, guest_count: 1, nights: 1
};
var SKIP_CUSTOM_COL = {
  A: 1, B: 1, C: 1, D: 1, E: 1, F: 1, G: 1, H: 1, I: 1, J: 1, K: 1,
  owner_income: 1, income: 1, stay_tax: 1
};
var ZERO_AST = { op: 'const', value: 0 };
var NOTICE_ITEMS_SAVED = '項目の変更内容を保存しました';
var NOTICE_TEMPLATE_SAVED = '現在の編集内容を\nフォーマットとして\n保存しました';
var NOTICE_DRAFT_SAVED = '変更内容を保存しました';
var NOTICE_UPDATED = '変更内容を更新しました';
var NOTICE_PUBLISHED = '変更内容を更新しました';
var CONFIRM_APPLY_TEMPLATE = 'フォーマットを適応すると\n現在の設定は上書きされます。\n本当に適応しますか？';
var CONFIRM_DELETE_TEMPLATE = '削除データの復元は不可能です\n本当に削除しますか？';
var PICK_ROOM_TOAST = '少なくとも1つの民宿を選択してください';
var CATALOG_LABELS = EXTRA_ITEM_CATALOG.slice();
var VAR_FROM_LABEL = {
  '人数': 'guest_count',
  '日数': 'nights',
  '収入額': 'income',
  '収入': 'income',
  '宿泊税': 'stay_tax',
  'A総売上': 'A',
  'Bサイト手数料': 'B',
  'C弊社報酬': 'C',
  'D清掃費': 'D',
  'Eアメニティ': 'E',
  'F消耗品': 'F',
  'Gクリーニング': 'G',
  'Hウエルカムシャンパン': 'H'
};

export default {
  name: 'pl-landlord-settlement-edit',
  components: {
    StaffMockHost: StaffMockHost,
    DialogConfirm: DialogConfirm,
    DialogNotice: DialogNotice,
    ImportantNotice: ImportantNotice,
    VarList: VarList,
    FormulaEdit: FormulaEdit,
    FormulaTip: FormulaTip
  },
  data: function () {
    var now = new Date();
    return {
      landlordId: 0,
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      settlement: {},
      landlord: {},
      items: [],
      stays: [],
      expandedRoomIds: {},
      yearRows: [],
      annualSeq: 0,
      formulaLabels: {
        A: 'A総売上',
        B: 'Bサイト手数料',
        C: 'C弊社報酬',
        D: 'D清掃費',
        E: 'Eアメニティ',
        F: 'F消耗品',
        G: 'Gクリーニング',
        H: 'Hウエルカムシャンパン'
      },
      ijkHeads: [
        { code: 'B', label: 'Bサイト手数料' },
        { code: 'C', label: 'C弊社報酬' },
        { code: 'D', label: 'D清掃費' },
        { code: 'E', label: 'Eアメニティ' },
        { code: 'F', label: 'F消耗品' },
        { code: 'G', label: 'Gクリーニング' },
        { code: 'H', label: 'Hシャンパン' },
        { code: 'I', label: 'Iサイトコントローラー' },
        { code: 'J', label: 'Jゴミ収集' },
        { code: 'K', label: 'K使用人' }
      ],
      formulas: {},
      formulaKeys: FORMULA_KEYS.slice(),
      rounding: 'floor',
      comment: '',
      commentHidden: false,
      savedComment: '',
      activeKey: 'F',
      pendingAction: '',
      pendingRounding: '',
      busy: false,
      addingLabel: '',
      addingAxis: '',
      pickedRoomIds: {},
      pendingRoomIds: [],
      templates: [],
      templateId: 0,
      pendingTemplateId: 0,
      templateName: '',
      templateRenameName: '',
      renamingTemplate: null,
      noticePlain: false,
      customCatalogLabel: '',
      customCatalogAmount: '',
      sourceMonths: [],
      copyKey: '',
      copyPickYear: new Date().getFullYear(),
      copyPickMonth: 0,
      horizontalOrder: null,
      sideMode: 'vertical',
      snapshot: null,
      noticeBody: NOTICE_ITEMS_SAVED,
      ui: {
        confirm: false,
        varList: false,
        formulaEdit: false,
        catalog: false,
        template: false,
        copyFrom: false,
        notice: false,
        reviseNotice: false,
        monthPick: false,
        templateName: false
      },
      confirmBody: ''
    };
  },
  computed: {
    landlordName: function () {
      var l = this.landlord || {};
      if (l.name) return l.name;
      return ((l.lastname || '') + (l.firstname || '')) || '';
    },
    isPublished: function () {
      return this.settlement && this.settlement.status === 'published';
    },
    eyeOpenIcon: function () {
      return this.isPublished
        ? '/assets/img/landlord/icon-eye-open-disabled.png'
        : '/assets/img/landlord/icon-eye-open.png';
    },
    isRepublish: function () {
      if (this.isPublished) return false;
      var s = this.settlement || {};
      return Number(s.publish_count) >= 1;
    },
    hasContentSaved: function () {
      var s = this.settlement || {};
      if (s.content_saved_at) return true;
      return Number(s.publish_count) >= 1;
    },
    tokyoNow: function () {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Tokyo',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }).formatToParts(new Date());
      var map = {};
      var i;
      for (i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;
      return {
        year: Number(map.year),
        month: Number(map.month),
        day: Number(map.day)
      };
    },
    currentMonthClosed: function () {
      var now = this.tokyoNow;
      if (Number(this.year) !== now.year || Number(this.month) !== now.month) return false;
      return now.day >= 15;
    },
    monthOffset: function () {
      var now = this.tokyoNow;
      return (Number(this.year) - now.year) * 12 + (Number(this.month) - now.month);
    },
    canPublish: function () {
      if (this.isPublished) return false;
      if (this.monthOffset > 0) return false;
      if (this.monthOffset === 0 && this.tokyoNow.day < 15) return false;
      return true;
    },
    editLocked: function () {
      return this.isPublished || this.currentMonthClosed;
    },
    copyYears: function () {
      var years = [];
      var list = this.sourceMonths || [];
      var i;
      for (i = 0; i < list.length; i++) {
        var y = Number(list[i] && list[i].year);
        if (y && years.indexOf(y) < 0) years.push(y);
      }
      years.sort(function (a, b) { return a - b; });
      return years;
    },
    landlordAvatarStyle: function () {
      var url = this.landlord && this.landlord.avatar_url;
      if (!url) return {};
      return { backgroundImage: 'url(' + this.url(url) + ')' };
    },
    contractLine: function () {
      var l = this.landlord || {};
      var parts = [];
      if (l.contract_start) parts.push('契約開始 ' + String(l.contract_start).slice(0, 10));
      if (l.contract_years) parts.push(String(l.contract_years) + '年');
      if (l.note) parts.push(l.note);
      return parts.join('　');
    },
    columnExtras: function () {
      var t = this;
      return (this.extraItems || []).filter(function (extra) {
        return t.itemPlace(extra) === 'column';
      });
    },
    amountExtras: function () {
      var t = this;
      return (this.extraItems || []).filter(function (extra) {
        return t.itemPlace(extra) === 'row';
      });
    },
    visibleColumnExtras: function () {
      return (this.columnExtras || []).filter(function (extra) {
        return extra && extra.visible !== 0 && extra.visible !== false;
      });
    },
    visibleAmountExtras: function () {
      return (this.amountExtras || []).filter(function (extra) {
        return extra && extra.visible !== 0 && extra.visible !== false;
      });
    },
    editorSpan: function () {
      return 7 + this.visibleFormulaKeys.length + this.visibleColumnExtras.length;
    },
    tableSpan: function () {
      return this.editorSpan + 1;
    },
    flatMiddle: function () {
      return Math.max(0, this.tableSpan - 3);
    },
    isSavedPreview: function () {
      var q = (this.$route && this.$route.query) || {};
      return q.preview === 'saved';
    },
    staysTablePx: function () {
      var map = { A: 80, B: 96, C: 80, D: 80, E: 80, F: 104, G: 104, H: 104 };
      var w = 24 + 96 + 96 + 48 + 48 + 80 + 80 + 104;
      var i;
      var keys = this.visibleFormulaKeys || [];
      for (i = 0; i < keys.length; i++) w += map[keys[i]] || 80;
      w += (this.visibleColumnExtras || []).length * 80;
      w += Math.max(0, this.tableSpan - 1) * 4;
      return w + 8;
    },
    transferTotal: function () {
      var sum = 0;
      (this.stays || []).forEach(function (stay) {
        var n = Number(stay && stay.ownerIncome);
        if (isFinite(n)) sum += n;
      });
      return this.formatNum(sum);
    },
    visibleFormulaKeys: function () {
      var t = this;
      return (this.formulaKeys || []).filter(function (key) {
        return t.isKeyOn(key);
      });
    },
    contractRateText: function () {
      var item = this.findItem('C');
      var ast = item && item.formula_json;
      var rate = null;
      var args = ast && ast.op === '*' ? (ast.args || []) : [];
      var i;
      var node;
      var val;
      for (i = 0; i < args.length; i++) {
        node = args[i];
        if (!node || node.op !== 'const') continue;
        val = Number(node.value);
        if (val > 0 && val < 1) {
          val = val * 100;
          rate = Math.abs(val - Math.round(val)) < 0.05 ? String(Math.round(val)) : String(Math.round(val * 10) / 10);
          break;
        }
      }
      return rate == null ? '売上高〇〇％契約' : ('売上高' + rate + '％契約');
    },
    horizontalLabels: function () {
      var base = (this.horizontalOrder || CATALOG_LABELS).slice();
      var seen = {};
      var i;
      for (i = 0; i < base.length; i++) seen[base[i]] = 1;
      (this.items || []).forEach(function (it) {
        var ast = it && it.formula_json;
        if (!it || !it.label || seen[it.label]) return;
        if (!(ast && ast.place === 'row')) return;
        seen[it.label] = 1;
        base.push(it.label);
      });
      return base;
    },
    formulaColumnLabels: function () {
      var labels = [];
      var keys = this.formulaKeys || [];
      var i;
      for (i = 0; i < keys.length; i++) {
        labels.push(this.formulaLabels[keys[i]] || keys[i]);
      }
      (this.columnExtras || []).forEach(function (extra) {
        if (extra && extra.label) labels.push(extra.label);
      });
      return labels;
    },
    extraItems: function () {
      return (this.items || []).filter(function (it) {
        return it && it.code && !SKIP_EXTRA[it.code];
      }).slice().sort(function (a, b) {
        var sa = a.sort == null ? 0 : Number(a.sort);
        var sb = b.sort == null ? 0 : Number(b.sort);
        if (sa !== sb) return sa - sb;
        return String(a.code).localeCompare(String(b.code));
      });
    },
    customCols: function () {
      return (this.items || []).filter(function (it) {
        return it && it.code && it.visible && !SKIP_CUSTOM_COL[it.code];
      }).slice().sort(function (a, b) {
        var sa = a.sort == null ? 0 : Number(a.sort);
        var sb = b.sort == null ? 0 : Number(b.sort);
        if (sa !== sb) return sa - sb;
        return String(a.code).localeCompare(String(b.code));
      });
    },
    catalogLabels: function () {
      var t = this;
      return CATALOG_LABELS.filter(function (name) {
        return !t.labelExists(name);
      });
    },
    stayDetailColspan: function () {
      return 6
        + (this.formulaKeys ? this.formulaKeys.length : 0)
        + (this.customCols ? this.customCols.length : 0);
    },
    ijk: function () {
      return this.sumIjk(this.stays);
    },
    pickerYears: function () {
      var selected = Number(this.year) || new Date().getFullYear();
      var now = new Date().getFullYear();
      var start = Math.min(2024, selected);
      var end = Math.max(now + 4, selected);
      var list = [];
      var i;
      for (i = start; i <= end; i++) list.push(i);
      return list;
    },
    pickerMonths: function () {
      var list = [];
      var m;
      for (m = 1; m <= 12; m++) list.push(m);
      return list;
    },
    yearOptions: function () {
      var cur = new Date().getFullYear();
      var y = this.year || cur;
      var start = Math.min(2024, y, cur - 1);
      var end = Math.max(y, cur + 1);
      var list = [];
      for (var i = start; i <= end; i++) list.push(i);
      return list;
    },
    activeCostName: function () {
      if (this.addingAxis) return this.addingLabel || '';
      var item = this.findItem(this.activeKey);
      if (item && item.label) return item.label;
      return this.formulaLabels[this.activeKey] || 'F消耗品';
    },
    activeFormula: function () {
      if (this.addingAxis) return '0';
      return this.formulas[this.activeKey] || '';
    },
    activeFormulaAst: function () {
      if (this.addingAxis) return ZERO_AST;
      var item = this.findItem(this.activeKey);
      return (item && item.formula_json) || null;
    },
    activeRemark: function () {
      if (this.addingAxis) return '';
      var item = this.findItem(this.activeKey);
      return (item && item.remark) || '';
    }
  },
  created: function () {
    this.initFromQuery();
    if (this.isSavedPreview) {
      this.applySavedPreview();
      return;
    }
    this.captureSnapshot();
    this.loadShow();
  },
  watch: {
    '$route.query.landlord_id': function () {
      this.initFromQuery();
      this.loadShow();
    },
    'ui.formulaEdit': function (open) {
      if (!open) {
        this.addingLabel = '';
        this.addingAxis = '';
      }
    }
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastFail: function (status, msg) {
      if (msg === 'closed') this.toast('15日0時以降は変更できません');
      else if (msg === 'future') this.toast('翌月以降は下書きのみ保存できます');
      else if (msg === 'early') this.toast('15日以降に公開できます');
      else if (status == 403 || msg === 'published') this.toast('公開済みのため変更できません');
      else if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else if (msg === '内容を入力してください' || msg === '内容が長すぎます') this.toast(msg);
      else this.toast('取得に失敗しました');
    },
    toastPublished: function () {
      this.toast('公開済みのため変更できません');
    },
    initFromQuery: function () {
      var q = (this.$route && this.$route.query) || {};
      var now = new Date();
      this.landlordId = parseInt(q.landlord_id, 10) || 0;
      var y = parseInt(q.year, 10);
      var m = parseInt(q.month, 10);
      this.year = (y >= 2000 && y <= 2100) ? y : now.getFullYear();
      this.month = (m >= 1 && m <= 12) ? m : (now.getMonth() + 1);
    },
    onPeriodChange: function () {
      this.loadShow();
    },
    openVarList: function () {
      if (this.guardPublished()) return;
      this.ui.varList = true;
    },
    findItem: function (code) {
      var list = this.items || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].code === code) return list[i];
      }
      return null;
    },
    isKeyOn: function (key) {
      var item = this.findItem(key);
      if (!item) return true;
      return item.visible !== 0 && item.visible !== false;
    },
    toggleKey: function (key) {
      if (this.guardPublished()) return;
      var item = this.findItem(key);
      if (!item) return;
      this.toggleExtra(item);
    },
    moveKey: function (key, dir) {
      if (this.guardPublished() || this.busy) return;
      var keys = (this.formulaKeys || []).slice();
      var from = keys.indexOf(key);
      var to = from + dir;
      if (from < 0 || to < 0 || to >= keys.length) return;
      var moved = keys.splice(from, 1)[0];
      keys.splice(to, 0, moved);
      this.formulaKeys = keys;
      var t = this;
      keys.forEach(function (code, idx) {
        var item = t.findItem(code);
        if (item) t.$set(item, 'sort', idx + 1);
      });
    },
    toggleSideMode: function () {
      this.sideMode = this.sideMode === 'vertical' ? 'horizontal' : 'vertical';
    },
    formulaColWidth: function (key) {
      var map = { A: 80, B: 96, C: 80, D: 80, E: 80, F: 104, G: 104, H: 104 };
      return (map[key] || 80) + 'px';
    },
    headerText: function (code, fallback) {
      var item = this.findItem(code);
      if (item && item.header_label) return item.header_label;
      var label = (item && item.label) || fallback || this.formulaLabels[code] || code;
      var remark = item && item.remark ? String(item.remark) : '';
      return remark ? (label + '\n' + remark) : label;
    },
    sideLabel: function (code) {
      var item = this.findItem(code);
      if (item && item.header_label && item.label) return item.label;
      var label = (item && item.label) || this.formulaLabels[code] || code;
      return String(label).replace(/^[A-H]/, '');
    },
    applySavedPreview: function () {
      var q = (this.$route && this.$route.query) || {};
      if (!q.year) this.year = 2025;
      if (!q.month) this.month = 6;
      var sample = 'サンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキスト';
      var keys = [
        { code: 'A', label: '総売上', header_label: 'A総売上' },
        { code: 'B', label: 'サイト手数料（A+C%）', header_label: 'Bサイト手数料\n（A〇％）' },
        { code: 'C', label: '弊社報酬（A+C%）', header_label: 'C弊社報酬\n（A〇％）' },
        { code: 'D', label: '清掃費', header_label: 'D清掃費' },
        { code: 'E', label: 'アメニティ', header_label: 'Eアメニティ' },
        { code: 'F', label: '消耗品（100*人数*日数）', header_label: 'F消耗品\n〇〇〇円*人数*日数' },
        { code: 'G', label: 'クリーニング（800*人数）', header_label: 'Gクリーニング\n〇〇〇円*人数' },
        { code: 'H', label: 'ウェルカムシャンパン', header_label: 'Hウエルカム\nシャンパン' }
      ];
      this.settlement = {
        status: 'published',
        rounding: 'ceil',
        publish_count: 1,
        content_saved_at: '2025-06-01 00:00:00',
        comment: sample,
        comment_hidden: 0
      };
      this.landlord = {
        name: '〇〇〇〇〇〇〇〇〇〇〇〇〇〇',
        avatar_url: '/assets/img/landlord/profile-sample.jpg',
        bank_name: '〇〇信用銀行',
        bank_branch: '○○支店',
        bank_account_no: '134514',
        bank_account_name: '○○太郎',
        invoice_reg_no: 'T5161436568757946'
      };
      this.items = keys.map(function (row, idx) {
        return {
          code: row.code,
          label: row.label,
          header_label: row.header_label,
          visible: 1,
          sort: idx + 1,
          remark: '',
          formula_json: { op: 'const', value: 0 }
        };
      }).concat([
        { code: 'X1', label: 'サイト\nコントローラー', visible: 1, sort: 20, remark: '', formula_json: { op: 'const', value: 789456 } },
        { code: 'X2', label: 'ゴミ収集', visible: 1, sort: 21, remark: '', formula_json: { op: 'const', value: 46856 } },
        { code: 'X3', label: '使用人', visible: 1, sort: 22, remark: '', formula_json: { op: 'const', value: 564231 } }
      ]);
      this.rounding = 'ceil';
      this.comment = sample;
      this.commentHidden = false;
      this.savedComment = sample;
      this.stays = [1, 2, 3].map(function (id) {
        return {
          id: id,
          name: '〇〇邸',
          days: 4,
          people: 7,
          income: 10000000,
          tax: 0,
          ownerIncome: 1000000,
          amounts: { owner_income: 1000000, adr: 0, occupancy: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, H: 0, I: 0, J: 0, K: 0 },
          A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, H: 0,
          stayRows: [
            {
              order_id: id * 10 + 1,
              checkin: '2025-01-01',
              checkout: '2025-01-03',
              nights: 3,
              guest_count: 1,
              income: 10000000,
              stay_tax: 0,
              owner_income: 1000000,
              hidden: 0,
              A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, H: 0
            },
            {
              order_id: id * 10 + 2,
              checkin: '2025-01-04',
              checkout: '',
              nights: 1,
              guest_count: 6,
              income: 0,
              stay_tax: 0,
              owner_income: 0,
              hidden: 1,
              A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, H: 0
            },
            {
              order_id: 0,
              checkin: '',
              checkout: '',
              nights: null,
              guest_count: null,
              income: null,
              stay_tax: null,
              owner_income: null,
              hidden: 0,
              A: null, B: null, C: null, D: null, E: null, F: null, G: null, H: null
            }
          ]
        };
      });
      this.templates = [1, 2, 3, 4, 5, 6, 7].map(function (id) {
        return { id: id, name: '〇〇〇〇' };
      });
      this.yearRows = [];
      this.syncFormulaFromItems();
      this.overlayYearFromStays();
      this.captureSnapshot();
    },
    formatNum: function (n) {
      if (n == null || n === '') return '';
      var num = Number(n);
      if (!isFinite(num)) return n;
      return String(Math.round(num)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    amtNum: function (amt, upper, lower) {
      if (!amt) return 0;
      if (amt[upper] !== undefined && amt[upper] !== null && amt[upper] !== '') {
        return Number(amt[upper]) || 0;
      }
      if (lower && amt[lower] !== undefined && amt[lower] !== null && amt[lower] !== '') {
        return Number(amt[lower]) || 0;
      }
      return 0;
    },
    sumIjk: function (rooms) {
      var ijk = {
        b: 0, c: 0, d: 0, e: 0, f: 0, g: 0, h: 0,
        i: 0, j: 0, k: 0, taxed: 0, taxOut: 0, taxRate: 0
      };
      var taxOut = 0;
      var taxRate = 0;
      var t = this;
      (rooms || []).forEach(function (room) {
        var amt = (room && room.amounts) || {};
        IJK_KEYS.forEach(function (k) {
          var lk = k.toLowerCase();
          ijk[lk] += t.amtNum(amt, k, lk);
        });
        taxOut += t.amtNum(amt, 'tax_excl', 'taxExcl');
        if (!taxRate && amt.tax_rate) taxRate = Number(amt.tax_rate) || 0;
      });
      ijk.taxed = ijk.c + ijk.d + ijk.e + ijk.f + ijk.g + ijk.h + ijk.i + ijk.j + ijk.k;
      ijk.taxOut = taxOut;
      ijk.taxRate = taxRate || 10;
      var out = {};
      ['b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'taxed', 'taxOut'].forEach(function (k) {
        out[k] = t.formatNum(ijk[k]);
      });
      out.taxRate = ijk.taxRate + '％';
      return out;
    },
    emptyMonths: function () {
      var list = [];
      for (var i = 0; i < 12; i++) {
        list.push({ profit: '—', adr: '—', occ: '—' });
      }
      return list;
    },
    formatOcc: function (n) {
      if (n === null || n === undefined || n === '') return '—';
      var v = Number(n);
      if (!isFinite(v)) return '—';
      if (v <= 1) v = v * 100;
      if (v === 100) return '100％';
      var r = Math.round(v * 100) / 100;
      if (r === Math.round(r)) return r + '％';
      return r.toFixed(2) + '％';
    },
    formatCell: function (v, kind) {
      if (v === null || v === undefined || v === '') return '—';
      if (kind === 'occ') return this.formatOcc(v);
      return this.formatNum(v);
    },
    overlayYearFromStays: function () {
      var t = this;
      var mi = (this.month || 1) - 1;
      if (mi < 0 || mi > 11) return;
      (this.stays || []).forEach(function (stay) {
        if (!stay) return;
        var amt = stay.amounts || {};
        var target = null;
        for (var i = 0; i < t.yearRows.length; i++) {
          if (t.yearRows[i].id === stay.id) {
            target = t.yearRows[i];
            break;
          }
        }
        if (!target) {
          target = { id: stay.id, name: stay.name, months: t.emptyMonths() };
          t.yearRows.push(target);
        }
        var months = target.months.slice();
        var profit = amt.owner_income;
        if (profit == null) profit = stay.ownerIncome;
        months[mi] = {
          profit: t.formatCell(profit),
          adr: t.formatCell(amt.adr),
          occ: t.formatCell(amt.occupancy, 'occ')
        };
        t.$set(target, 'months', months);
      });
    },
    applyAnnual: function (opt) {
      var t = this;
      var rooms = (opt && opt.rooms) || [];
      this.yearRows = rooms.map(function (room) {
        var cells = room.months || [];
        var months = t.emptyMonths();
        for (var i = 0; i < 12; i++) {
          var cell = cells[i] || {};
          months[i] = {
            profit: t.formatCell(cell.profit),
            adr: t.formatCell(cell.adr),
            occ: t.formatCell(cell.occupancy, 'occ')
          };
        }
        return {
          id: room.room_id,
          name: room.room_name,
          months: months
        };
      });
      this.overlayYearFromStays();
    },
    loadAnnual: function () {
      var t = this;
      this.annualSeq += 1;
      var seq = this.annualSeq;
      if (!this.landlordId) {
        this.yearRows = [];
        return;
      }
      axios.get('settlement/annual', {
        params: { landlord_id: this.landlordId, year: this.year }
      }).then(function (res) {
        if (seq !== t.annualSeq) return;
        if (res.data && res.data.status == 1 && res.data.options) {
          t.applyAnnual(res.data.options);
          return;
        }
        t.yearRows = [];
      }).catch(function () {
        if (seq !== t.annualSeq) return;
        t.yearRows = [];
      });
    },
    mapStayRows: function (stays) {
      if (!Array.isArray(stays)) return [];
      return stays.map(function (stay) {
        stay = stay || {};
        var row = {
          order_id: stay.order_id,
          checkin: stay.checkin || '',
          checkout: stay.checkout || '',
          nights: stay.nights,
          guest_count: stay.guest_count,
          income: stay.income,
          stay_tax: stay.stay_tax,
          owner_income: stay.owner_income,
          hidden: stay.hidden ? 1 : 0
        };
        Object.keys(stay).forEach(function (key) {
          if (row[key] == null) row[key] = stay[key];
        });
        return row;
      });
    },
    goList: function () {
      this.$router.push({ path: '/pl_landlord' });
    },
    toggleMonthPick: function () {
      closeAllFormulaTips();
      this.ui.monthPick = !this.ui.monthPick;
      if (!this.ui.monthPick) return;
      var t = this;
      this.$nextTick(function () {
        t.placeMonthPop();
        t.scrollMonthPick();
      });
    },
    closeMonthPick: function () {
      this.ui.monthPick = false;
    },
    placeMonthPop: function () {
      var title = this.$refs.pageTitle;
      var pop = this.$refs.monthPop;
      if (!title || !pop) return;
      var rect = title.getBoundingClientRect();
      var width = pop.offsetWidth || 177;
      var left = rect.left + (rect.width - width) / 2;
      var top = rect.bottom + 6;
      if (left < 8) left = 8;
      if (left + width > window.innerWidth - 8) left = window.innerWidth - width - 8;
      pop.style.left = left + 'px';
      pop.style.top = top + 'px';
    },
    scrollMonthPick: function () {
      this.centerPickCol(this.$refs.yearCol);
      this.centerPickCol(this.$refs.monthCol);
    },
    centerPickCol: function (col) {
      if (!col) return;
      var btn = col.querySelector('.is-current');
      if (!btn) return;
      col.scrollTop = btn.offsetTop - (col.clientHeight - btn.offsetHeight) / 2;
    },
    padMonth: function (m) {
      m = Number(m) || 0;
      return (m < 10 ? '0' : '') + m;
    },
    pickYear: function (y) {
      y = Number(y);
      if (!y || y === Number(this.year)) return;
      this.year = y;
      this.onPeriodChange();
      var t = this;
      this.$nextTick(function () {
        t.scrollMonthPick();
      });
    },
    pickMonth: function (m) {
      m = Number(m);
      if (!m || m === Number(this.month)) return;
      this.month = m;
      this.onPeriodChange();
      var t = this;
      this.$nextTick(function () {
        t.scrollMonthPick();
      });
    },
    codeOfLabel: function (name) {
      var item = this.findItemByLabel(name);
      return item ? item.code : '';
    },
    formulaText: function (code) {
      if (!code) return '';
      var item = this.findItem(code);
      var printed = this.printFormula(item && item.formula_json);
      if (printed) return printed;
      var saved = this.formulas[code];
      return saved ? String(saved) : '';
    },
    formulaVarLabel: function (name) {
      var map = {
        guest_count: '人数',
        nights: '日数',
        income: '収入額',
        stay_tax: '宿泊税'
      };
      if (map[name]) return map[name];
      if (this.formulaLabels[name]) return this.formulaLabels[name];
      var item = this.findItem(name);
      if (item && item.label) return item.label;
      return name || '';
    },
    printFormula: function (node) {
      if (typeof node === 'string') {
        try {
          node = JSON.parse(node);
        } catch (e) {
          return '';
        }
      }
      if (!node || typeof node !== 'object') return '';
      var op = node.op;
      if (op === 'const') return node.value == null ? '' : String(node.value);
      if (op === 'var') return this.formulaVarLabel(node.name);
      var args = node.args || [];
      var parts = [];
      var i;
      for (i = 0; i < args.length; i++) parts.push(this.printFormula(args[i]));
      if (!parts.length) return '';
      var sep = op === '*' ? ' × ' : (' ' + (op || '') + ' ');
      return parts.join(sep);
    },
    shiftPeriod: function (delta) {
      var m = Number(this.month) + delta;
      var y = Number(this.year);
      if (m < 1) {
        m = 12;
        y -= 1;
      } else if (m > 12) {
        m = 1;
        y += 1;
      }
      if (y < 2000 || y > 2100) return;
      this.year = y;
      this.month = m;
      this.onPeriodChange();
    },
    mapRooms: function (rooms) {
      var keys = this.formulaKeys;
      var t = this;
      return (rooms || []).map(function (room) {
        var amt = room.amounts || {};
        var row = {
          id: room.room_id,
          name: room.room_name,
          days: room.nights,
          people: room.guest_count,
          income: room.income,
          tax: room.stay_tax,
          ownerIncome: amt.owner_income,
          amounts: amt,
          stayRows: t.mapStayRows(room.stays)
        };
        keys.forEach(function (k) {
          row[k] = amt[k];
        });
        (t.customCols || []).forEach(function (col) {
          row[col.code] = amt[col.code];
        });
        return row;
      });
    },
    hasStayRows: function (stay) {
      return !!(stay && stay.stayRows && stay.stayRows.length);
    },
    isRoomPicked: function (stay) {
      return !!(stay && this.pickedRoomIds && this.pickedRoomIds[stay.id]);
    },
    toggleRoomPick: function (stay) {
      if (!stay || stay.id == null) return;
      var on = !!(this.pickedRoomIds && this.pickedRoomIds[stay.id]);
      var next = {};
      if (!on) next[stay.id] = true;
      this.pickedRoomIds = next;
    },
    pickedRooms: function () {
      var map = this.pickedRoomIds || {};
      return (this.stays || []).filter(function (stay) {
        return stay && map[stay.id];
      });
    },
    cellNumber: function (value) {
      if (value == null || value === '') return null;
      if (typeof value === 'number') return isFinite(value) ? value : null;
      var s = String(value).replace(/,/g, '').trim();
      if (!/^-?\d+(\.\d+)?$/.test(s)) return null;
      var n = Number(s);
      return isFinite(n) ? n : null;
    },
    stayTotalCells: function (stay) {
      var span = this.tableSpan;
      var cols = [];
      var i;
      for (i = 0; i < span; i++) cols.push([]);
      var t = this;
      function pushRow(values) {
        var c;
        for (c = 0; c < span; c++) cols[c].push(c < values.length ? values[c] : '');
      }
      if (!this.hasStayRows(stay)) {
        var placeholder = ['', '', '', stay.days, stay.people, stay.income, stay.tax];
        (this.visibleFormulaKeys || []).forEach(function (key) {
          placeholder.push(stay[key]);
        });
        (this.visibleColumnExtras || []).forEach(function (col) {
          placeholder.push(stay[col.code]);
        });
        placeholder.push(stay.ownerIncome);
        pushRow(placeholder);
      }
      (stay.stayRows || []).forEach(function (row) {
        if (row && row.hidden) return;
        var values = [
          '',
          row.checkin,
          row.checkout,
          row.nights,
          row.guest_count,
          row.income,
          row.stay_tax
        ];
        (t.visibleFormulaKeys || []).forEach(function (key) {
          values.push(row[key]);
        });
        (t.visibleColumnExtras || []).forEach(function (col) {
          values.push(row[col.code]);
        });
        values.push(row.owner_income);
        pushRow(values);
      });
      (this.visibleAmountExtras || []).forEach(function (extra) {
        var values = ['', extra.label];
        var n;
        for (n = 0; n < t.flatMiddle; n++) values.push('');
        values.push(t.extraAmount(extra, stay));
        pushRow(values);
      });
      if (this.isSavedPreview) {
        var zeros = [''];
        for (i = 1; i < span; i++) zeros.push(0);
        pushRow(zeros);
      }
      return cols.map(function (cells) {
        var sum = 0;
        var numeric = 0;
        cells.forEach(function (value) {
          var n = t.cellNumber(value);
          if (n == null) return;
          numeric += 1;
          sum += n;
        });
        if (!numeric) return '〇';
        return t.formatNum(sum);
      });
    },
    itemPlace: function (item) {
      var ast = item && item.formula_json;
      if (ast && ast.place === 'column') return 'column';
      if (ast && ast.place === 'row') return 'row';
      if (ast && ast.op === 'const') return 'row';
      return 'column';
    },
    stampPlace: function (ast, place) {
      var copy;
      try {
        copy = JSON.parse(JSON.stringify(ast));
      } catch (e) {
        copy = ast;
      }
      if (copy && place) copy.place = place;
      return copy;
    },
    addSideItem: function (axis) {
      if (this.guardPublished() || this.busy) return;
      this.addingAxis = axis === 'row' ? 'row' : 'column';
      this.addingLabel = '';
      this.activeKey = '';
      this.ui.formulaEdit = true;
    },
    isStayExpanded: function (stay) {
      if (!stay || stay.id == null) return false;
      return !!this.expandedRoomIds[stay.id];
    },
    toggleStayRows: function (stay) {
      if (!this.hasStayRows(stay)) return;
      var id = stay.id;
      if (this.expandedRoomIds[id]) {
        this.$delete(this.expandedRoomIds, id);
      } else {
        this.$set(this.expandedRoomIds, id, true);
      }
    },
    applyOptions: function (opt) {
      opt = opt || {};
      var s = opt.settlement || {};
      this.settlement = s;
      this.landlord = opt.landlord || {};
      this.items = (opt.items || []).map(function (it) {
        return Object.assign({}, it);
      });
      this.rounding = s.rounding === 'ceil' ? 'ceil' : 'floor';
      this.comment = s.comment == null ? '' : String(s.comment);
      this.commentHidden = !!(Number(s.comment_hidden));
      this.savedComment = this.comment;
      this.stays = this.mapRooms(opt.rooms);
      this.syncFormulaFromItems();
      this.overlayYearFromStays();
      this.captureSnapshot();
      this.loadAnnual();
    },
    cloneState: function (v) {
      return JSON.parse(JSON.stringify(v == null ? null : v));
    },
    captureSnapshot: function () {
      this.snapshot = {
        items: this.cloneState(this.items || []),
        comment: this.comment == null ? '' : String(this.comment),
        commentHidden: !!this.commentHidden,
        rounding: this.rounding,
        formulas: this.cloneState(this.formulas || {}),
        formulaLabels: this.cloneState(this.formulaLabels || {}),
        stays: this.cloneState(this.stays || []),
        settlement: this.cloneState(this.settlement || {})
      };
    },
    restoreSnapshot: function () {
      var s = this.snapshot;
      if (!s) return;
      this.items = this.cloneState(s.items || []);
      this.comment = s.comment == null ? '' : String(s.comment);
      this.commentHidden = !!s.commentHidden;
      this.savedComment = this.comment;
      this.rounding = s.rounding === 'ceil' ? 'ceil' : 'floor';
      this.formulas = this.cloneState(s.formulas || {});
      this.formulaLabels = this.cloneState(s.formulaLabels || {});
      this.stays = this.cloneState(s.stays || []);
      this.settlement = this.cloneState(s.settlement || {});
      this.syncFormulaFromItems();
      this.overlayYearFromStays();
    },
    itemsDirty: function () {
      if (!this.snapshot) return true;
      return JSON.stringify(this.items || []) !== JSON.stringify(this.snapshot.items || []);
    },
    commentDirty: function () {
      var cur = this.comment == null ? '' : String(this.comment);
      var old = this.snapshot ? this.snapshot.comment : this.savedComment;
      return cur !== (old == null ? '' : String(old));
    },
    syncFormulaFromItems: function () {
      var t = this;
      var ranked = [];
      (this.items || []).forEach(function (it) {
        if (!it || !it.code) return;
        if (FORMULA_KEYS.indexOf(it.code) < 0) return;
        if (it.label) t.$set(t.formulaLabels, it.code, it.label);
        ranked.push(it);
      });
      ranked.sort(function (a, b) {
        var ds = (Number(a.sort) || 0) - (Number(b.sort) || 0);
        if (ds) return ds;
        return FORMULA_KEYS.indexOf(a.code) - FORMULA_KEYS.indexOf(b.code);
      });
      if (!ranked.length) return;
      var keys = ranked.map(function (it) { return it.code; });
      FORMULA_KEYS.forEach(function (code) {
        if (keys.indexOf(code) < 0) keys.push(code);
      });
      this.formulaKeys = keys;
    },
    monthParams: function () {
      return {
        landlord_id: this.landlordId,
        year: this.year,
        month: this.month
      };
    },
    handleRes: function (res, onOk) {
      var status = res.data.status;
      var msg = res.data.msg;
      if (msg === 'closed') {
        this.toast('15日0時以降は変更できません');
        return false;
      }
      if (msg === 'future') {
        this.toast('翌月以降は下書きのみ保存できます');
        return false;
      }
      if (msg === 'early') {
        this.toast('15日以降に公開できます');
        return false;
      }
      if (status == 403 || msg === 'published') {
        this.toastPublished();
        return false;
      }
      if (status != 1) {
        this.toastFail(status, msg);
        return false;
      }
      if (onOk) onOk(res.data.options);
      return true;
    },
    loadShow: function () {
      if (this.isSavedPreview) {
        this.applySavedPreview();
        return;
      }
      this.expandedRoomIds = {};
      this.yearRows = [];
      if (!this.landlordId) {
        this.toast('オーナーが指定されていません');
        this.stays = [];
        this.items = [];
        this.settlement = {};
        this.landlord = {};
        this.yearRows = [];
        this.templates = [];
        this.templateId = 0;
        this.comment = '';
        this.savedComment = '';
        this.captureSnapshot();
        return;
      }
      this.loadTemplates();
      var t = this;
      axios.get('settlement/show', { params: this.monthParams() }).then(function (res) {
        t.handleRes(res, function (opt) {
          t.applyOptions(opt);
        });
      }).catch(function () {
        t.toast('通信に失敗しました');
      });
    },
    postSave: function (extra, applyResult) {
      if (this.isSavedPreview) return Promise.resolve(false);
      var t = this;
      extra = extra || {};
      var body = Object.assign({
        landlord_id: this.landlordId,
        year: this.year,
        month: this.month
      }, extra);
      return axios.post('settlement/save', body).then(function (res) {
        if (!t.handleRes(res, function (opt) {
          if (applyResult === false) {
            var s = (opt && opt.settlement) || {};
            if (opt && opt.settlement) t.settlement = opt.settlement;
            t.savedComment = s.comment == null ? '' : String(s.comment);
            return;
          }
          t.applyOptions(opt);
        })) return false;
        return true;
      }).catch(function () {
        t.toast('通信に失敗しました');
        return false;
      });
    },
    onCommentBlur: function () {
      if (this.editLocked) return;
      this.comment = this.comment == null ? '' : String(this.comment);
    },
    guardPublished: function () {
      if (this.currentMonthClosed) {
        this.toast('15日0時以降は変更できません');
        return true;
      }
      if (!this.isPublished) return false;
      this.toastPublished();
      return true;
    },
    syncRoundingRadios: function () {
      var t = this;
      this.$nextTick(function () {
        if (!t.$el) return;
        var nodes = t.$el.querySelectorAll('.pl-settle-round input[name="rounding"]');
        var i;
        for (i = 0; i < nodes.length; i++) {
          nodes[i].checked = nodes[i].value === t.rounding;
        }
      });
    },
    setRounding: function (mode) {
      this.syncRoundingRadios();
      if (this.editLocked || mode === this.rounding) return;
      this.pendingAction = 'rounding';
      this.pendingRounding = mode;
      if (mode === 'floor') {
        this.confirmBody = '小数点以下を切り捨てました';
      } else {
        this.confirmBody = '小数点以下を繰り上げました';
      }
      this.ui.confirm = true;
    },
    openCopyPicker: function () {
      if (this.guardPublished()) return;
      this.copyPickMonth = 0;
      this.copyPickYear = Number(this.year) || new Date().getFullYear();
      this.syncCopyYear();
      this.ui.copyFrom = true;
      this.loadSourceMonths();
    },
    closeCopyPicker: function () {
      this.ui.copyFrom = false;
      this.copyPickMonth = 0;
    },
    loadSourceMonths: function () {
      var t = this;
      if (!this.landlordId) {
        this.sourceMonths = [];
        this.copyKey = '';
        this.syncCopyYear();
        return;
      }
      axios.get('settlement/sourceMonths', {
        params: { landlord_id: this.landlordId }
      }).then(function (res) {
        if (!t.handleRes(res)) return;
        var opt = res.data.options || {};
        var list = opt.items || [];
        var cur = t.year + '-' + t.month;
        t.sourceMonths = list.filter(function (row) {
          return row && (row.year + '-' + row.month) !== cur;
        });
        if (t.copyKey && !t.sourceMonths.some(function (row) { return (row.year + '-' + row.month) === t.copyKey; })) {
          t.copyKey = '';
        }
        t.syncCopyYear();
      }).catch(function () {
        t.toast('通信に失敗しました');
      });
    },
    syncCopyYear: function () {
      var years = this.copyYears;
      if (!years.length) {
        this.copyPickYear = Number(this.year) || new Date().getFullYear();
        return;
      }
      if (years.indexOf(Number(this.copyPickYear)) >= 0) {
        if (this.copyPickMonth && !this.copyMonthOn(this.copyPickYear, this.copyPickMonth)) this.copyPickMonth = 0;
        return;
      }
      var cur = Number(this.year);
      var pick = years[0];
      var i;
      for (i = 0; i < years.length; i++) {
        if (years[i] <= cur) pick = years[i];
      }
      this.copyPickYear = pick;
      this.copyPickMonth = 0;
    },
    canShiftCopyYear: function (dir) {
      var years = this.copyYears;
      var idx = years.indexOf(Number(this.copyPickYear));
      return idx >= 0 && years[idx + dir] != null;
    },
    shiftCopyYear: function (dir) {
      var years = this.copyYears;
      var idx = years.indexOf(Number(this.copyPickYear));
      var next = idx + dir;
      if (idx < 0 || next < 0 || next >= years.length) return;
      this.copyPickYear = years[next];
      if (!this.copyMonthOn(this.copyPickYear, this.copyPickMonth)) this.copyPickMonth = 0;
    },
    copyMonthOn: function (year, month) {
      return (this.sourceMonths || []).some(function (row) {
        return Number(row.year) === Number(year) && Number(row.month) === Number(month);
      });
    },
    pickCopyMonth: function (month) {
      if (!this.copyMonthOn(this.copyPickYear, month)) return;
      this.copyPickMonth = month;
    },
    confirmCopyPicker: function () {
      if (this.guardPublished()) return;
      if (!this.copyPickMonth || !this.copyMonthOn(this.copyPickYear, this.copyPickMonth)) {
        this.toast('参照する月を選んでください');
        return;
      }
      this.copyKey = this.copyPickYear + '-' + this.copyPickMonth;
      this.ui.copyFrom = false;
      this.confirmCopyFrom();
    },
    adrCell: function (room) {
      var mi = (Number(this.month) || 1) - 1;
      var cell = room && room.months && room.months[mi] ? room.months[mi] : null;
      return cell || { profit: '—', adr: '—', occ: '—' };
    },
    findItemByLabel: function (name) {
      var list = this.items || [];
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i] && list[i].label === name) return list[i];
      }
      return null;
    },
    horizontalOn: function (name) {
      var item = this.findItemByLabel(name);
      return !!(item && item.visible !== 0 && item.visible !== false);
    },
    toggleHorizontal: function (name) {
      if (this.guardPublished()) return;
      var item = this.findItemByLabel(name);
      if (item) {
        this.toggleExtra(item);
        return;
      }
      this.insertFlatExtra(name, 0);
    },
    moveHorizontal: function (name, dir) {
      if (this.guardPublished() || this.busy) return;
      var list = this.horizontalLabels.slice();
      var from = list.indexOf(name);
      var to = from + dir;
      if (from < 0 || to < 0 || to >= list.length) return;
      var moved = list.splice(from, 1)[0];
      list.splice(to, 0, moved);
      this.horizontalOrder = list;
      var t = this;
      list.forEach(function (label, idx) {
        var item = t.findItemByLabel(label);
        if (item) t.$set(item, 'sort', idx + 1);
      });
    },
    openHorizontal: function (name) {
      if (this.guardPublished()) return;
      var item = this.findItemByLabel(name);
      if (!item) return;
      this.addingLabel = '';
      this.addingAxis = '';
      this.activeKey = item.code;
      this.ui.formulaEdit = true;
    },
    removeHorizontal: function (name) {
      this.removeExtra(this.findItemByLabel(name));
    },
    removeExtra: function (item) {
      if (this.guardPublished() || this.busy || !item) return;
      var idx = this.items.indexOf(item);
      if (idx >= 0) this.items.splice(idx, 1);
    },
    moveTemplate: function (idx, dir) {
      var next = idx + dir;
      if (next < 0 || next >= this.templates.length) return;
      var list = this.templates.slice();
      var row = list.splice(idx, 1)[0];
      list.splice(next, 0, row);
      this.templates = list;
    },
    applyTemplateRow: function (tpl) {
      if (!tpl || this.editLocked || this.busy) return;
      var rooms = this.pickedRooms();
      if (!rooms.length) {
        this.toast(PICK_ROOM_TOAST);
        return;
      }
      this.templateId = tpl.id;
      this.pendingRoomIds = rooms.map(function (stay) { return stay.id; });
      this.openApplyTemplate();
    },
    removeTemplate: function (tpl) {
      if (!tpl || !tpl.id || this.busy) return;
      this.pendingTemplateId = tpl.id;
      this.pendingAction = 'deleteTemplate';
      this.confirmBody = CONFIRM_DELETE_TEMPLATE;
      this.ui.confirm = true;
    },
    confirmCopyFrom: function () {
      if (this.guardPublished()) return;
      if (!this.copyKey) {
        this.toast('参照する月を選んでください');
        return;
      }
      this.pendingAction = 'copyFrom';
      this.confirmBody = '選んだ月の列だけをコピーします。\n金額はこの月の注文で計算します。\nよろしいですか？';
      this.ui.confirm = true;
    },
    openTemplate: function () {
      this.ui.template = !this.ui.template;
      if (this.ui.template) this.loadTemplates();
    },
    openApplyTemplate: function () {
      if (this.guardPublished()) return;
      var names = this.pickedRooms().map(function (stay) { return stay.name; }).filter(Boolean);
      this.pendingAction = 'template';
      this.confirmBody = names.length
        ? ('選択した民宿（' + names.join('、') + '）に\n' + CONFIRM_APPLY_TEMPLATE)
        : CONFIRM_APPLY_TEMPLATE;
      this.ui.confirm = true;
    },
    findTemplate: function (id) {
      var list = this.templates || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].id == id) return list[i];
      }
      return null;
    },
    loadTemplates: function (preferId) {
      var t = this;
      if (!this.landlordId) {
        this.templates = [];
        this.templateId = 0;
        return;
      }
      axios.get('settlement/templates', {
        params: { landlord_id: this.landlordId }
      }).then(function (res) {
        if (!t.handleRes(res)) return;
        var opt = res.data.options || {};
        var list = opt.items || [];
        t.templates = list;
        var want = preferId != null ? parseInt(preferId, 10) : parseInt(t.templateId, 10);
        if (isNaN(want)) want = 0;
        t.templateId = t.findTemplate(want) ? want : (list.length ? list[0].id : 0);
      }).catch(function () {
        t.toast('通信に失敗しました');
      });
    },
    doDeleteTemplate: function () {
      var id = this.pendingTemplateId;
      this.pendingTemplateId = 0;
      if (!id) return;
      var t = this;
      this.busy = true;
      axios.post('settlement/templates/delete', { id: id }).then(function (res) {
        t.busy = false;
        if (!t.handleRes(res)) return;
        t.templates = (t.templates || []).filter(function (row) {
          return row.id != id;
        });
        if (t.templateId == id) t.templateId = t.templates.length ? t.templates[0].id : 0;
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    },
    saveCurrentTemplate: function () {
      var rooms = this.pickedRooms();
      if (!rooms.length) {
        this.toast(PICK_ROOM_TOAST);
        return;
      }
      var name = rooms[0] && rooms[0].name ? String(rooms[0].name) : '';
      this.persistTemplate(null, name);
    },
    saveTemplateRow: function (tpl) {
      this.persistTemplate(tpl || null);
    },
    openTemplateName: function (tpl) {
      if (!tpl || this.busy) return;
      this.renamingTemplate = tpl;
      this.templateRenameName = tpl.name || '';
      this.ui.templateName = true;
    },
    closeTemplateName: function () {
      if (this.busy) return;
      this.ui.templateName = false;
      this.renamingTemplate = null;
    },
    saveTemplateName: function () {
      var tpl = this.renamingTemplate;
      var name = String(this.templateRenameName || '').replace(/^\s+|\s+$/g, '');
      if (!tpl || this.busy) return;
      if (!name) {
        this.toast('名前を入力してください');
        return;
      }
      if (!this.landlordId) {
        this.toast('オーナーが指定されていません');
        return;
      }
      var t = this;
      var id = parseInt(tpl.id, 10);
      if (isNaN(id) || id < 1) id = 0;
      var payload = {
        landlord_id: this.landlordId,
        name: name,
        rounding: tpl.rounding || this.rounding,
        items: tpl.items || []
      };
      if (id > 0) {
        payload.id = id;
        payload.name_only = 1;
      }
      this.busy = true;
      axios.post('settlement/templates', payload).then(function (res) {
        t.busy = false;
        if (!t.handleRes(res, function (opt) {
          var row = opt || {};
          if (row.id) {
            var idx = -1;
            (t.templates || []).forEach(function (item, i) {
              if (item && item.id == row.id) idx = i;
            });
            if (idx >= 0) t.$set(t.templates, idx, row);
            else t.templates = (t.templates || []).concat([row]);
            t.templateId = row.id;
          }
          t.ui.templateName = false;
          t.renamingTemplate = null;
          t.loadTemplates(row.id);
        })) return;
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    },
    persistTemplate: function (tpl, nameOverride) {
      if (this.busy) return;
      if (!this.landlordId) {
        this.toast('オーナーが指定されていません');
        return;
      }
      var t = this;
      var id = tpl ? parseInt(tpl.id, 10) : 0;
      if (isNaN(id) || id < 1) id = 0;
      var name = nameOverride != null && String(nameOverride) !== ''
        ? String(nameOverride)
        : (tpl && tpl.name ? tpl.name : this.templateName);
      var payload = {
        landlord_id: this.landlordId,
        name: name,
        rounding: this.rounding,
        items: this.items
      };
      if (id > 0) payload.id = id;
      this.busy = true;
      axios.post('settlement/templates', payload).then(function (res) {
        t.busy = false;
        if (!t.handleRes(res, function (opt) {
          var row = opt || {};
          if (row.id) {
            var idx = -1;
            (t.templates || []).forEach(function (item, i) {
              if (item && item.id == row.id) idx = i;
            });
            if (idx >= 0) t.$set(t.templates, idx, row);
            else t.templates = (t.templates || []).concat([row]);
            t.templateId = row.id;
          }
          t.loadTemplates(row.id);
          t.noticePlain = false;
          t.noticeBody = NOTICE_TEMPLATE_SAVED;
          t.ui.notice = true;
        })) return;
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    },
    onSaveDraft: function () {
      if (this.currentMonthClosed) {
        this.toast('15日0時以降は変更できません');
        return;
      }
      if (this.isPublished) {
        this.toastPublished();
        return;
      }
      if (this.busy) return;
      if (this.hasContentSaved) {
        this.ui.reviseNotice = true;
        return;
      }
      this.commitDraft();
    },
    onReviseNoticeSend: function (text) {
      this.commitDraft(text);
    },
    commitDraft: function (noticeBody) {
      var t = this;
      var payload = {
        rounding: this.rounding,
        comment: this.comment,
        items: this.items,
        commit: 1
      };
      if (noticeBody) payload.notice_body = noticeBody;
      this.busy = true;
      this.postSave(payload).then(function (ok) {
        t.busy = false;
        if (!ok) return;
        t.ui.reviseNotice = false;
        t.noticePlain = false;
        t.noticeBody = NOTICE_UPDATED;
        t.ui.notice = true;
      });
    },
    onPublish: function () {
      if (this.isPublished) {
        this.toast('公開済み');
        return;
      }
      if (this.monthOffset > 0) {
        this.toast('翌月以降は下書きのみ保存できます');
        return;
      }
      if (this.monthOffset === 0 && this.tokyoNow.day < 15) {
        this.toast('15日以降に公開できます');
        return;
      }
      if (this.busy) return;
      this.doPublish();
    },
    onCancelEdit: function () {
      this.restoreSnapshot();
    },
    onConfirmOk: function () {
      var action = this.pendingAction;
      this.pendingAction = '';
      if (action === 'rounding') this.doSaveRounding();
      else if (action === 'copyFrom') this.doCopyFrom();
      else if (action === 'template') this.doApplyTemplate();
      else if (action === 'deleteTemplate') this.doDeleteTemplate();
    },
    onConfirmCancel: function () {
      if (this.pendingAction === 'copyFrom') this.copyKey = '';
      if (this.pendingAction === 'rounding') this.syncRoundingRadios();
      this.pendingAction = '';
      this.pendingRounding = '';
      this.pendingTemplateId = 0;
      this.pendingRoomIds = [];
    },
    doSaveRounding: function () {
      var mode = this.pendingRounding;
      var prev = this.rounding;
      this.pendingRounding = '';
      if (!mode || mode === prev) return;
      this.rounding = mode;
      var t = this;
      this.postSave({
        rounding: mode,
        items: this.items,
        comment: this.comment
      }).then(function (ok) {
        if (!ok) t.rounding = prev;
      });
    },
    doCopyFrom: function () {
      var parts = String(this.copyKey || '').split('-');
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10);
      if (!year || !month) return;
      this.ui.copyFrom = false;
      this.postSave({ copy_year: year, copy_month: month });
    },
    onReopen: function () {
      if (this.isSavedPreview) return;
      if (!this.isPublished || this.busy) return;
      var t = this;
      this.busy = true;
      axios.post('settlement/reopen', this.monthParams()).then(function (res) {
        t.busy = false;
        t.handleRes(res, function (opt) {
          t.applyOptions(opt);
        });
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    },
    toggleCommentHidden: function () {
      if (this.guardPublished()) return;
      this.commentHidden = !this.commentHidden;
      this.postSave({
        comment: this.comment,
        comment_hidden: this.commentHidden ? 1 : 0,
        items: this.items,
        rounding: this.rounding
      });
    },
    toggleStayHidden: function (row) {
      if (this.guardPublished()) return;
      if (!row || !row.order_id) return;
      row.hidden = row.hidden ? 0 : 1;
      var ids = [];
      (this.stays || []).forEach(function (stay) {
        (stay.stayRows || []).forEach(function (line) {
          if (line && line.hidden && line.order_id) ids.push(line.order_id);
        });
      });
      this.postSave({
        hidden_order_ids: ids,
        items: this.items,
        comment: this.comment,
        comment_hidden: this.commentHidden ? 1 : 0,
        rounding: this.rounding
      });
    },
    extraAmount: function (extra, stay) {
      var ast = extra && extra.formula_json;
      if (ast && ast.op === 'const' && ast.value != null) return this.formatNum(ast.value);
      var code = extra && extra.code;
      var raw = null;
      if (stay && code) {
        if (stay[code] != null && stay[code] !== '') raw = stay[code];
        else if (stay.amounts && stay.amounts[code] != null) raw = stay.amounts[code];
      }
      if (raw == null || raw === '') return '';
      return this.formatNum(raw);
    },
    doApplyTemplate: function () {
      var id = parseInt(this.templateId, 10);
      if (isNaN(id)) id = 0;
      var roomIds = (this.pendingRoomIds || []).slice();
      this.pendingRoomIds = [];
      if (!roomIds.length) {
        this.toast(PICK_ROOM_TOAST);
        return;
      }
      var payload = { room_ids: roomIds };
      if (id > 0) {
        payload.template_id = id;
        this.postSave(payload);
        return;
      }
      var picked = this.findTemplate(id);
      payload.items = picked && picked.items ? picked.items : [];
      this.postSave(payload);
    },
    doPublish: function () {
      if (this.busy) return;
      var t = this;
      var publishSaved = function () {
        axios.post('settlement/publish', t.monthParams()).then(function (res) {
          t.busy = false;
          t.handleRes(res, function (opt) {
            t.noticePlain = true;
            t.noticeBody = NOTICE_PUBLISHED;
            t.ui.notice = true;
            t.applyOptions(opt);
          });
        }).catch(function () {
          t.busy = false;
          t.toast('通信に失敗しました');
        });
      };
      this.busy = true;
      if (this.currentMonthClosed) {
        publishSaved();
        return;
      }
      this.postSave({
        rounding: this.rounding,
        comment: this.comment,
        items: this.items
      }).then(function (ok) {
        if (!ok) {
          t.busy = false;
          return;
        }
        publishSaved();
      });
    },
    isExtraOn: function (extra) {
      return !!(extra && extra.visible);
    },
    isCustomCode: function (code) {
      return !!(code && !RESERVED_CODES[code]);
    },
    labelExists: function (label) {
      if (!label) return false;
      var list = this.items || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].label === label) return true;
      }
      return false;
    },
    nextCustomCode: function () {
      var used = {};
      (this.items || []).forEach(function (it) {
        if (it && it.code) used[it.code] = 1;
      });
      var n = 1;
      var code = 'X' + n;
      while (used[code] || RESERVED_CODES[code]) {
        n += 1;
        code = 'X' + n;
      }
      return code;
    },
    nextExtraSort: function () {
      var max = 0;
      (this.items || []).forEach(function (it) {
        var s = it && it.sort != null ? Number(it.sort) : 0;
        if (s > max) max = s;
      });
      return max + 1;
    },
    clipRemark: function (raw) {
      var s = raw == null ? '' : String(raw);
      if (s.length > 12) s = s.slice(0, 12);
      return s;
    },
    openCatalog: function () {
      if (this.guardPublished()) return;
      this.ui.catalog = !this.ui.catalog;
    },
    pickCatalog: function (name) {
      if (this.guardPublished()) return;
      if (this.labelExists(name)) {
        this.toast('追加済み');
        return;
      }
      this.customCatalogLabel = name;
    },
    pickCustomLabel: function () {
      if (this.guardPublished()) return;
      var name = (this.customCatalogLabel || '').replace(/^\s+|\s+$/g, '');
      if (!name) {
        this.toast('項目名を入力してください');
        return;
      }
      var yen = parseInt(String(this.customCatalogAmount == null ? '' : this.customCatalogAmount).replace(/[^\d-]/g, ''), 10);
      if (!isFinite(yen)) yen = 0;
      this.insertFlatExtra(name, yen);
      this.customCatalogLabel = '';
      this.customCatalogAmount = '';
      this.ui.catalog = false;
    },
    insertFlatExtra: function (label, yen) {
      if (this.guardPublished()) return;
      this.items.push({
        code: this.nextCustomCode(),
        label: label,
        visible: 1,
        formula_json: { op: 'const', value: yen },
        remark: '',
        sort: this.nextExtraSort()
      });
    },
    insertCustomItem: function (fallbackLabel, payload) {
      if (this.guardPublished()) return;
      var item = {
        code: this.nextCustomCode(),
        label: (payload && payload.costName) || fallbackLabel,
        visible: 1,
        formula_json: payload.ast,
        remark: this.clipRemark(payload && payload.remark),
        sort: this.nextExtraSort()
      };
      this.items.push(item);
    },
    moveExtra: function (item, dir) {
      if (this.guardPublished()) return;
      if (this.busy) return;
      var extras = this.extraItems;
      var from = -1;
      for (var i = 0; i < extras.length; i++) {
        if (extras[i] === item || (item && extras[i].code === item.code)) {
          from = i;
          break;
        }
      }
      var to = from + dir;
      if (from < 0 || to < 0 || to >= extras.length) return;
      var snapshot = extras.map(function (it) { return it.sort; });
      var ordered = extras.slice();
      var moved = ordered.splice(from, 1)[0];
      ordered.splice(to, 0, moved);
      var sorts = snapshot.slice().sort(function (a, b) {
        return (Number(a) || 0) - (Number(b) || 0);
      });
      var unique = true;
      for (var s = 1; s < sorts.length; s++) {
        if (sorts[s] === sorts[s - 1]) unique = false;
      }
      if (!unique) {
        var max = 0;
        (this.items || []).forEach(function (it) {
          if (!it) return;
          var inOrdered = false;
          for (var k = 0; k < ordered.length; k++) {
            if (ordered[k] === it) {
              inOrdered = true;
              break;
            }
          }
          if (inOrdered) return;
          var n = Number(it.sort) || 0;
          if (n > max) max = n;
        });
        sorts = ordered.map(function (_, idx) { return max + 1 + idx; });
      }
      for (var j = 0; j < ordered.length; j++) {
        this.$set(ordered[j], 'sort', sorts[j]);
      }
    },
    openFormula: function (key) {
      if (this.guardPublished()) return;
      this.addingLabel = '';
      this.addingAxis = '';
      this.activeKey = key;
      this.ui.formulaEdit = true;
    },
    labelToVar: function (label) {
      if (!label) return '';
      if (VAR_FROM_LABEL[label]) return VAR_FROM_LABEL[label];
      var ch = String(label).charAt(0);
      if (ch >= 'A' && ch <= 'H') return ch;
      return '';
    },
    onPickVar: function (label) {
      if (this.guardPublished()) return;
      var key = this.activeKey || 'F';
      var item = this.findItem(key);
      var cur = this.formulas[key] || '';
      var next = cur ? (cur + ' × ' + label) : label;
      this.$set(this.formulas, key, next);
      var name = this.labelToVar(label);
      if (!item || !name) return;
      var node = { op: 'var', name: name };
      var ast = item.formula_json;
      if (ast && ast.op === '*') {
        ast = { op: '*', args: (ast.args || []).concat([node]) };
      } else if (ast && ast.op) {
        ast = { op: '*', args: [ast, node] };
      } else {
        ast = node;
      }
      this.$set(item, 'formula_json', ast);
    },
    onFormulaConfirm: function (payload) {
      if (!payload) return;
      if (!payload.ast) {
        this.toast('計算式を解析できません');
        return;
      }
      var name = String(payload.costName || '').replace(/^\s+|\s+$/g, '');
      if (!name) {
        this.toast('項目名を入力してください');
        return;
      }
      if (this.addingAxis) {
        if (this.labelExists(name)) {
          this.toast('追加済み');
          return;
        }
        this.insertCustomItem(name, {
          costName: name,
          ast: this.stampPlace(payload.ast, this.addingAxis),
          remark: payload.remark
        });
        this.addingAxis = '';
        this.addingLabel = '';
        return;
      }
      if (!this.activeKey) return;
      var item = this.findItem(this.activeKey);
      if (!item) return;
      var key = this.activeKey;
      var ast = payload.ast;
      if (this.isCustomCode(item.code)) ast = this.stampPlace(payload.ast, this.itemPlace(item));
      this.$set(item, 'label', name);
      this.$set(item, 'formula_json', ast);
      this.$set(item, 'remark', this.clipRemark(payload.remark));
      this.$set(this.formulaLabels, key, name);
      this.$set(this.formulas, key, payload.formula);
    },
    toggleExtra: function (item) {
      if (this.guardPublished()) return;
      if (!item) return;
      this.$set(item, 'visible', item.visible ? 0 : 1);
    }
  }
};
